import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import { HeadingArticle } from '../design-system/Headings';
import RichText, { FeatureHeadlineRenderer } from '../design-system/RichText';
import Paragraph from '../design-system/Paragraph';
import LoadingOverlay from '../components/LoadingOverlay';
import { LinkButton } from '../design-system/Buttons';
import phrasesType from '../proptypes/phrases';
import staticPageType from '../proptypes/static-page';

const OnboardingSuccessPage = ({
  content: {
    heading,
    body,
    heroImage,
  },
  fullName,
  dashboardPath,
  codeword,
  phrases,
}) => (
  <PageWrapper tallNav bgDark>
    <LoadingOverlay
      title={phrases.loadingOverlay.title}
      message={phrases.loadingOverlay.description}
      displayDuration={4000}
    />
    <PageSection hero center backgroundImage={{ url: heroImage }}>
      <HeadingArticle el="h1">
        {heading}
        <br />
        {fullName}
      </HeadingArticle>
    </PageSection>

    <PageSection container={false}>
      <Container small>
        <RichText paragraphRenderer={FeatureHeadlineRenderer} content={body} />
        <LinkButton w100 href={dashboardPath}>Access My Profile</LinkButton>
        {codeword && (
          <Paragraph center sub myLg>{`${phrases.citizenSpyCodeword}, "${codeword}"`}</Paragraph>
        )}
      </Container>
    </PageSection>
  </PageWrapper>
);

OnboardingSuccessPage.defaultProps = {
  fullName: null,
  codeword: undefined,
};

OnboardingSuccessPage.propTypes = {
  fullName: PropTypes.string,
  dashboardPath: PropTypes.string.isRequired,
  content: staticPageType.isRequired,
  codeword: PropTypes.string,
  phrases: phrasesType.isRequired,
};

export default hot(OnboardingSuccessPage);
